import { RUN_APP, APP, URL_KEY_FOR_RUN_APP } from '@common/loan-act/env'
import { domain } from '@finance/domain'

export const ACT_CODE = {
  [APP.ssj]: 'ssj_travel', // 线上
  [APP.kn]: 'ssj_travel', // 线上
}[RUN_APP]

export const SHARE_CONF = {
  title: '「旅游记账」就选随手记！',
  content: '给你推荐一个旅游必备神器，轻松解决出行记账难题，马上点击查看！',
  url: `${domain.res}/act/loan-2020-travel-books/index.html#/?${URL_KEY_FOR_RUN_APP}=${RUN_APP}`
}

export const AWARD_URL = `${domain.res}/public-vue/loan-operation-tool/index.html#/my-reward/list?actCode=${ACT_CODE}`

export const BOOKS_URL = 'https://t.feidee.com/switchBook?storeId=30408&requiredCreate=true&requiredSyncBook=true&requiredVisitorBook=true'
